import { Helmet } from "react-helmet-async";
import SATFullTestSelectorBox from "../../components/SATFullTestSelectorBox/SATFullTestSelectorBox";
import SATReadingAndWritingSelectorBox from "../../components/SATReadingAndWritingSelectorBox/SATReadingAndWritingSelectorBox";
import SATMathSelectorBox from "../../components/SATMathSelectorBox/SATMathSelectorBox";
import UserHeaderBar from "../../components/userHeaderBar/userHeaderBar";
import { isFeatureEnabled, FEATURES } from "../../utils/featureFlags";
import styles from "../../publicAsset/userSATPracticePage.module.scss";

const UserSATPracticePage = () => {

    return (
        <>
            <Helmet>
                <title>User SAT Practice | Prepal</title>
                <meta name="description" content="User SAT Practice for Prepal account holders." />
                <meta name="keywords" content="Prepal, user SAT practice, education" />
                <meta name="author" content="Prepal Team" />
            </Helmet>

            <div className={styles.userSATPracticePage}>
                <UserHeaderBar />
                <div className={styles.userTestCategory}>
                    {isFeatureEnabled(FEATURES.FULL_LENGTH_TEST) && (
                        <SATFullTestSelectorBox />
                    )}
                    <SATReadingAndWritingSelectorBox />
                    <SATMathSelectorBox />
                </div>
            </div>
        </>

    );
};

export default UserSATPracticePage;
